import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const apiUrl = `${environment.apiBaseUrl}`;

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {

  /** Shared empty headers instance is safe (HttpHeaders is immutable); options objects must be per-request. */
  private readonly defaultHeaders = new HttpHeaders();

  constructor(private http: HttpClient) { }

  get<T>(serviceEndpoint: string, params: HttpParams): Observable<T> {
    const url = `${apiUrl}${serviceEndpoint}`;
    return this.http.get<T>(url, { headers: this.defaultHeaders, params });
  }

  post<T>(serviceEndpoint: string, data: any): Observable<T> {
    const url = `${apiUrl}${serviceEndpoint}`;
    return this.http.post<T>(url, data, { headers: this.defaultHeaders });
  }

  postAsCompleteUrl<T>(url: string, data: any): Observable<T> {
    return this.http.post<T>(url, data, { headers: this.defaultHeaders });
  }

  postWithOptionsAsCompleteUrl(url: string, data: any, options: any): Observable<any> {
    return this.http.post<any>(url, data, options);
  }

  getAsCompleteUrl<T>(url: string): Observable<T> {
    return this.http.get<T>(url, { headers: this.defaultHeaders });
  }

  getAsCompleteUrlWithParams<T>(url: string, params: HttpParams): Observable<T> {
    return this.http.get<T>(url, { headers: this.defaultHeaders, params });
  }

  getAsCompleteUrlPlain<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }
}
